import { render, staticRenderFns } from "./EmployeeManagementNewAdd.vue?vue&type=template&id=2df48ad6"
import script from "./EmployeeManagementNewAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeManagementNewAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports